import PatientAppointment from 'components/atoms/icons/patientAppointmentIcon';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import AppointmentCard from './components/appointment-card';
import s from './styles.module.scss';
import MonthlyAppointmentTable from './components/mothly-appointment-table';

interface Props {
  patientGuid: string;
  disableActions?: boolean;
}

const PatientAppointmentDetails: FC<Props> = ({
  patientGuid,
  disableActions = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper} id="appointment-details">
      <h4 className={s.title}>
        <PatientAppointment />
        {t('labels.patientAppointmentDetails')}
      </h4>
      <div className={s.body}>
        <AppointmentCard
          patientGuid={patientGuid}
          disableActions={disableActions}
        />
        <MonthlyAppointmentTable
          patientGuid={patientGuid}
          disableActions={disableActions}
        />
      </div>
    </div>
  );
};
export default PatientAppointmentDetails;
